import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Scroll from 'react-scroll';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';

import GenericModelAPI from '../../api/GenericModelAPI';
import ApiUiController from '../../controller/ApiUiController';
import ModelController from '../../controller/ModelController';
import FieldController from '../../controller/FieldController';
import Util from '../../util/Util';
import ConditionalFieldUtil from '../settings/fields/conditional/ConditionalFieldUtil';
import ModelAddUpdateGroup from './ModelAddUpdateGroup';

import { LeadDesign } from './ModelAddUpdateDesign';
import PropertyAPI from '../../api/PropertyAPI';

class ModelAddUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.ModelNo = parseInt(props.model_no);
    this.ModelId = parseInt(props.match.params.id);

    this.modules = reactLocalStorage.getObject(Const.Model);
    if(this.ModelNo === Const.Lead) {
      this.MoldeName = 'lead';
      this.module = this.modules[this.MoldeName];
      this.setDesign(this.module.fields, LeadDesign)
    }
    
    const model = ModelController.addModel(this.module.fields);
    this.state = { inApiCall: this.ModelId !== 0, model, inValid: {}};

    // this is for next and prev edit
    const query = new URLSearchParams(props.location.search);
    this.iItem = query.get('indx') ? parseInt(query.get('indx')) : 0;
    this.lItem = query.get('size') ? parseInt(query.get('size')) : 0;
    const isNext = this.iItem !== 0 && this.lItem !== 0;
    this.saveLink = `${isNext ? `?indx=${this.iItem}&size=${this.lItem}` : ''}`;
    this.base = this.props.match.path;
    this.base = this.base.substring(0, this.base.indexOf('/add-edit'));
  }

  componentDidMount() { 
    if(this.ModelId !== 0) { 
      GenericModelAPI.get(this.MoldeName, this.ModelId, this.onReceived); 
    } 
  }

  setDesign = (fields, Design) => {
    const MaxOrder = Math.max(...Design.map(item => item.order));
    const AdditionalFields = {
      order: MaxOrder + 1,
      title: 'Additional Information',
      fields: []
    };

    let ModuleFields = Object.keys(fields);
    ModuleFields = ModuleFields.filter(field => field !== 'created_by' && field !== 'created_date' 
      && field !== 'updated_by' && field !== 'updated_date' && field !== 'status'
    );

    this.ConditionalFields = ModuleFields.map(key => {
      const field = fields[key];
      const visible = field.visible === Const.True;
      const editable = field.editable === Const.True;
      const mandatory = field.form_mandate === Const.True;
      let options = FieldController.getOptions(field);
      options = options 
        ? options.map(option => { return { label: option.label, value: option.value, 
            status: option.status, visible: true } })
        : options;
      return { field: key, visible, editable, mandatory, options, error: false, errorMessage: '' };
    });

    for (let i in ModuleFields) {
      const item = Design.find(innerDesign => 
        innerDesign.fields.find(innerField => innerField === ModuleFields[i]));
      if(!item) {
        AdditionalFields.fields.push(ModuleFields[i]);
      }
    }
    this.Design = [ ...Design.sort((l, r) => l.order - r.order), AdditionalFields];
  }

  onSave = async() => {
    this.ConditionalFields = this.ConditionalFields.map(
      item => { return { ...item, error: false, errorMessage: '' }});
    const model = ModelController.getServerModel(this.module.fields, this.state.model);
    const inValid = ModelController.validate(this.module.fields, this.ConditionalFields, model);
    if(!inValid) {
      //if(this.MoldeName === 'lead'){
      //  const propertyCount = await(this.onPropertiesCount(model));
      //  model['property_count'] = propertyCount || 0;
      //}
      this.setState({ ...this.state, inApiCall: true });
      GenericModelAPI.save(this.MoldeName, { ...model, id: this.ModelId },
        this.onUpdateReceived, this.failure);
        Util.showNotification('Successful', 'Lead saved successfully', 'success');
    } else {
      Util.showError(Util.failure(inValid, this.module));
      ModelController.setError(inValid, this.ConditionalFields);
      Scroll.scroller.scrollTo(Object.keys(inValid)[0], { duration: 1500, smooth: true });
      this.setState({ ...this.state, inValid: { ...inValid } });
    }
  }

  failure = res => {
    let tmp = res;
    if(typeof res === 'string') {
      tmp = JSON.parse(res);
    }
    Util.showError(Util.failure(tmp, this.module));
    ModelController.setError(tmp, this.ConditionalFields);
    Scroll.scroller.scrollTo(Object.keys(tmp)[0], { duration: 1500, smooth: true });
    this.setState({ ...this.state, inApiCall: false, inValid: { ...tmp } });
  }

  onReceived = serverModel => {
    const model = ModelController.getModelFromServer(this.module.fields, serverModel);
    this.setState({ ...this.state, model, inApiCall: false });
  }

  onUpdateReceived = model => this.props.navigate(`${this.base}/preview/${model.id}${this.saveLink}`);

  onValueChange = (field, value) => {
    const model = { ...this.state.model };
    model[field] = value;
    ConditionalFieldUtil.apply(this.module, this.ConditionalFields, model, field);
    this.setState({ ...this.state, model });
  }
  
  render() {
    return (
      <div className="sectionform">
        <div className="container form-cont">
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              
              { this.Design.map((item, i) => 
                <ModelAddUpdateGroup 
                  key={`group_${i}`}
                  model={this.state.model}
                  module={this.module}
                  onValueChange={this.onValueChange}
                  inValid={this.state.inValid}
                  design={item}
                  conditionalFields={this.ConditionalFields}
                />
              )}

              <div className="col-md-12 text-center btnsend">
                <Button className="buttons btn-success" onClick={this.onSave}>
                  { this.ModelId === 0 ? 'Save' : 'Update' } Lead
                </Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}

export default withRouter(ModelAddUpdate);